import axios from 'axios'
import { BASE_URL } from './Api';

const instance = axios.create({
    baseURL: BASE_URL,
    timeout: 20000,
});

// Request interceptor to add token to every request
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle 401 errors
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid - redirect to login
            localStorage.removeItem('adminToken');
            localStorage.removeItem('user');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

// Function to set the token in localStorage
function setToken(newToken) {
    localStorage.setItem('adminToken', newToken);
}

// Get Request
const getRequest = (path) => {
    return instance.get(path);
}

// Post Request
const postRequest = (path, data) => {
    return instance.post(path, data);
}

// Put Request (for full updates)
const putRequest = (path, data) => {
    return instance.put(path, data);
}

// Patch Request (for partial updates)
const patchRequest = (path, data) => {
    return instance.patch(path, data);
}

// Delete Request
const deleteRequest = (path, data = null) => {
    if (data) {
        return instance.delete(path, { data });
    }
    return instance.delete(path);
}

export { getRequest, postRequest, putRequest, patchRequest, deleteRequest, setToken }
